export const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === 'true';

const BASE_URL_ACCOUNTS = {
  develop: 'https://api-develop-accounts.helixa.ai',
  staging: 'https://api-staging-accounts.helixa.ai',
  production: 'https://api-accounts.helixa.ai',
};

const BASE_URL_WORKSPACE = {
  develop: 'https://api-develop-workspace.helixa.ai',
  staging: 'https://api-staging-workspace.helixa.ai',
  production: 'https://api-workspace.helixa.ai',
};

const BASE_URL_ENGINE = {
  develop: 'https://api-develop-engine.helixa.ai/core',
  staging: 'https://api-staging-engine.helixa.ai/core',
  production: 'https://api-engine.helixa.ai/core',
};

const BASE_URL_ENGINE_AFFINITY = {
  develop: 'https://api-develop-engine.helixa.ai/affinity',
  staging: 'https://api-staging-engine.helixa.ai/affinity',
  production: 'https://api-engine.helixa.ai/affinity',
};

const BASE_URL_AFFINITY = {
  develop: 'https://api-develop-affinity.helixa.ai',
  staging: 'https://api-staging-affinity.helixa.ai',
  production: 'https://api-affinity.helixa.ai',
};

const BASE_URL_WEBSOCKET = {
  develop: 'wss://ffqyl2ri7c.execute-api.us-west-2.amazonaws.com/develop',
  staging: 'wss://2njzumvpzc.execute-api.us-west-2.amazonaws.com/staging',
  production: 'wss://f99r0h3pg8.execute-api.us-west-2.amazonaws.com/production',
};

const BASE_URL_EXPORT = {
  develop: 'https://api-develop-export-service.helixa.ai',
  staging: 'https://api-staging-export-service.helixa.ai',
  production: 'https://api-export-service.helixa.ai',
};

const BASE_URL_QUERY_MEMBERSHIP = {
  develop: 'https://api-develop-engine.helixa.ai/membership',
  staging: 'https://api-staging-engine.helixa.ai/membership',
  production: 'https://api-engine.helixa.ai/membership',
};

const MOCK_BASE_URL_WORKSPACE = IS_LOCAL
  ? 'http://localhost:6001'
  : '//hx-workspace-mock-api.herokuapp.com';

const MOCK_BASE_URL_ENGINE = IS_LOCAL
  ? 'http://localhost:4001'
  : '//helixa-engine-mock-api.herokuapp.com';

const MOCK_BASE_URL_AFFINITY =
  process.env.REACT_APP_IS_LOCAL === 'true'
    ? 'http://localhost:4001/affinity'
    : '//helixa-engine-mock-api.herokuapp.com/affinity';

const MOCK_BASE_URL_EXPORT =
  process.env.REACT_APP_IS_LOCAL === 'true'
    ? 'http://localhost:7001'
    : '//helixa-engine-mock-api.herokuapp.com/export';

const SSO_URLS = {
  localhost: {
    REACT_APP_ID_SERVER_BASE: `//localhost-home.helixa.ai:3003`,
    REACT_APP_ID_SERVER_AUTH: `//localhost-home.helixa.ai:3003/login`,
  },
  develop: {
    REACT_APP_ID_SERVER_BASE: `//develop-home.helixa.ai`,
    REACT_APP_ID_SERVER_AUTH: `//develop-home.helixa.ai/login`,
  },
  staging: {
    REACT_APP_ID_SERVER_BASE: '//staging-home.helixa.ai',
    REACT_APP_ID_SERVER_AUTH: '//staging-home.helixa.ai/login',
  },
  production: {
    REACT_APP_ID_SERVER_BASE: '//home.helixa.ai',
    REACT_APP_ID_SERVER_AUTH: '//home.helixa.ai/login',
  },
};

const HELIXA_ID_TOKEN = 'HELIXA_ID_TOKEN';
const HELIXA_ACCESS_TOKEN = 'HELIXA_ACCESS_TOKEN';
const HELIXA_REFRESH_TOKEN = 'HELIXA_REFRESH_TOKEN';

const API = {
  ACCOUNTS: {
    BASE_URL: BASE_URL_ACCOUNTS[process.env.REACT_APP_API_ENV],
  },
  WORKSPACE: {
    BASE_URL: BASE_URL_WORKSPACE[process.env.REACT_APP_API_ENV],
    MOCK_BASE_URL: MOCK_BASE_URL_WORKSPACE,
  },
  ENGINE: {
    BASE_URL: BASE_URL_ENGINE[process.env.REACT_APP_API_ENV],
    MOCK_BASE_URL: MOCK_BASE_URL_ENGINE,
  },
  ENGINE_AFFINITY: {
    BASE_URL: BASE_URL_ENGINE_AFFINITY[process.env.REACT_APP_API_ENV],
  },
  AFFINITY: {
    BASE_URL: BASE_URL_AFFINITY[process.env.REACT_APP_API_ENV],
    MOCK_BASE_URL: MOCK_BASE_URL_AFFINITY,
  },
  EXPORT: {
    BASE_URL: BASE_URL_EXPORT[process.env.REACT_APP_API_ENV],
    MOCK_BASE_URL: MOCK_BASE_URL_EXPORT,
  },
  WEBSOCKET: BASE_URL_WEBSOCKET[process.env.REACT_APP_API_ENV],
  QUERY_MEMBERSHIP: {
    BASE_URL: BASE_URL_QUERY_MEMBERSHIP[process.env.REACT_APP_API_ENV],
  },
};

const BASE_URLS_MFE = {
  AFFINITY: {
    develop: IS_LOCAL
      ? 'http://localhost:3007'
      : 'https://d2xeiscdsuexi3.cloudfront.net',
    staging: IS_LOCAL
      ? 'http://localhost:3007'
      : 'https://d3n3fc70x7dcbi.cloudfront.net',
    production: IS_LOCAL
      ? 'http://localhost:3007'
      : 'https://d19tko8chv1fdi.cloudfront.net',
  },
  SEGMENTATION: {
    develop: IS_LOCAL
      ? 'http://localhost:3009'
      : 'https://d1qbmhhz3fpf9c.cloudfront.net',
    staging: IS_LOCAL
      ? 'http://localhost:3009'
      : 'https://d2smafl2bvlbq.cloudfront.net',
    production: IS_LOCAL
      ? 'http://localhost:3009'
      : 'https://dv1r1q6le5wg6.cloudfront.net',
  },
  COMPARE: {
    develop: IS_LOCAL
      ? 'http://localhost:3011'
      : 'https://dqcxu01pgi8ry.cloudfront.net',
    staging: IS_LOCAL
      ? 'http://localhost:3011'
      : 'https://dm9oc382bh6mw.cloudfront.net',
    production: IS_LOCAL
      ? 'http://localhost:3011'
      : 'https://d3pa53je6oudvp.cloudfront.net',
  },
};

const MFE_URLS = {
  AFFINITY: BASE_URLS_MFE.AFFINITY[process.env.REACT_APP_API_ENV],
  SEGMENTATION: BASE_URLS_MFE.SEGMENTATION[process.env.REACT_APP_API_ENV],
  COMPARE: BASE_URLS_MFE.COMPARE[process.env.REACT_APP_API_ENV],
};

const FILTER_LABELS_MAP = {
  recent: 'recent',
  search: 'Results',
  my: 'My Folders',
  template: 'Popular',
  conversation: 'Conversation',
};

const PRODUCTS_COLORS = {
  analyze: 'secondary',
  segmentation: 'secondary',
  compare: 'secondary',
};

const APPS_MAP = {
  ANALYZE: 'analyze',
  SEGMENTATION: 'segmentation',
  COMPARE: 'compare',
};

const PRODUCTS_ICONS = {
  analyze: 'analize',
  segmentation: 'segmentation_audience',
  compare: 'compare',
};

const PSYCHOGRAPHIC_PREFIX = 'psychographic__';

export {
  SSO_URLS,
  API,
  HELIXA_ID_TOKEN,
  HELIXA_ACCESS_TOKEN,
  HELIXA_REFRESH_TOKEN,
  FILTER_LABELS_MAP,
  PRODUCTS_COLORS,
  MFE_URLS,
  APPS_MAP,
  PRODUCTS_ICONS,
  PSYCHOGRAPHIC_PREFIX,
};
